/**
 * 送货单打印：数量列仅显示数值（不带单位），固定一位小数。
 */
export function formatDeliveryOrderPrintQuantity (num) {
  if (num === null || num === undefined || num === '') return '-'
  const n = Number(num)
  if (!Number.isFinite(n)) return String(num)
  return n.toFixed(1)
}
